import { Organization } from "../organization";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CallCenterTourStepEntityConfig } from "./config";
import { CallCenterTourStepFilters } from "./filters";
import { CallCenterTourStepMethods } from "./methods";

@HyperEntity<CallCenterTourStep>(
  "call-center-tour-step",
  CallCenterTourStepEntityConfig,
)
export class CallCenterTourStep extends extender(
  CallCenterTourStepFilters,
  CallCenterTourStepMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "organization_id", caption: "ארגון" })
  organizationId = "";

  @Relations.toOne(() => Organization, "organizationId")
  organization?: Organization;

  @Fields.string({ dbName: "anchor_key", caption: "עוגן" })
  anchorKey = "";

  @Fields.string({ caption: "כותרת משנה" })
  kicker = "";

  @Fields.string({ caption: "כותרת" })
  title = "";

  @Fields.string({ caption: "הסבר" })
  description = "";

  @Fields.string({ caption: "צד" })
  side = "bottom";

  @Fields.integer({ dbName: "sort_order", caption: "סדר" })
  sortOrder = 0;

  @Fields.boolean({ dbName: "is_active", caption: "פעיל" })
  isActive = true;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
